import { useCallback } from 'react';
import { useEventLeads } from './useEventLeads';

export function useParticipantLeadRecord(eventId, sponsorId, participantId) {
    const filter = useCallback((lead) => lead.sponsor_id == sponsorId && lead.participant_id == participantId, [sponsorId, participantId]);

    return useEventLeads(eventId, { filter })?.[0];
}
